__turbopack_context__.v({
  "container": "utility-nav-module-scss-module__6CDS0W__container",
  "utilityNav": "utility-nav-module-scss-module__6CDS0W__utilityNav",
  "utilityNavGrid": "utility-nav-module-scss-module__6CDS0W__utilityNavGrid",
  "utilityNavItem": "utility-nav-module-scss-module__6CDS0W__utilityNavItem",
  "utilityNavItem--contact": "utility-nav-module-scss-module__6CDS0W__utilityNavItem--contact",
  "utilityNavItem--languages": "utility-nav-module-scss-module__6CDS0W__utilityNavItem--languages",
  "utilityNavItem--location": "utility-nav-module-scss-module__6CDS0W__utilityNavItem--location",
  "utilityNavItems": "utility-nav-module-scss-module__6CDS0W__utilityNavItems",
});
